import pic1 from "../assets/pic1.png";
import React from "react";

export const showProfilePic = (pic, pic_path) => {
  return <img src={pic1} alt={"*"}/>
};